export default __webpack_public_path__ + "static/media/align-justify.9e51ab95.svg";